import React from "react";
import { Grid, styled } from "@mui/material/";

const useStyles = styled({
  img_data: {
    margin: "auto",
    height: "40%",
  },
});

export default function NoResultsComponent() {
  const classes = useStyles();
  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      xl={12}
      sx={{ display: "flex", justifyContent: "center", flexDirection: "row" }}
    >
      <img
        src={require("../../assets/gif/noResultsMerry.gif")}
        className={classes.img_data}
        alt='noreult'
      />
    </Grid>
  );
}
